import React, { useMemo, useState } from "react";
import { func, object, bool } from "prop-types";
import { Formik, Form, Field } from "formik";
import { Button } from "reactstrap";
import { FieldSpy } from "../../../../../components/formik";
import { CLIENT_SCORING_RESULT_SCORING_STATUS } from "../../../constants/clientScoringResultConstants";
import { clientScoringStatusValidationSchema } from "../../../validation-schemas";
import ChangeStatusConfirmModal from "../change-status-modal";
import FormikButtonSelectScoring from "../../../../../components/formik/ButtonSelectScoring";
import "./monitoringQueueEntryScoringChangeStatusForm.css";
import useRoles from "../../../../../components/hooks/useRoles";

const MonitoringQueueEntryScoringChangeStatusForm = ({
  handleSubmit,
  clientScoringResult,
  setDataChange,
  allHaveDecision,
  noneHaveDecision,
}) => {
  const disabledAllOnNoDecision = noneHaveDecision;
  const { isClient, isCoordinator, isManager, isMaster } = useRoles();
  const initialValues = {
    scoringStatus: clientScoringResult.scoringStatus,
    comment: "",
  };

  const [isOpenModal, setIsOpenDetails] = useState(false);

  const [scoringStatusValue, setScoringStatusValue] = useState(
    clientScoringResult.scoringStatus,
  );

  const buttonDisabled = useMemo(() => {
    if (clientScoringResult.scoringStatus !== scoringStatusValue) {
      return false;
    }

    return true;
  }, [scoringStatusValue]);

  const toggleModal = () => {
    setIsOpenDetails(!isOpenModal);
  };

  const handleScoringStatusChange = (status) => {
    setScoringStatusValue(status);
    setDataChange(true);
  };

  const canChangeScoringStatus =
    isCoordinator || isManager || isMaster || isClient;

  const isHighRisk =
    clientScoringResult.scoringStatus ===
      CLIENT_SCORING_RESULT_SCORING_STATUS.ApprovedHighRisk ||
    clientScoringResult.scoringStatus ===
      CLIENT_SCORING_RESULT_SCORING_STATUS.RejectedHighRisk;

  const isNotPending =
    clientScoringResult.scoringStatus !==
    CLIENT_SCORING_RESULT_SCORING_STATUS.Pending;

  const clientScoringResultScoringStatusOptions = () => {
    if (isMaster || isClient) {
      return [
        {
          value: CLIENT_SCORING_RESULT_SCORING_STATUS.Pending,
          label: "Pending",
          isDisabled: isNotPending,
        },
        {
          value: CLIENT_SCORING_RESULT_SCORING_STATUS.ApprovedHighRisk,
          label: "Approved High Risk",
        },
        {
          value: CLIENT_SCORING_RESULT_SCORING_STATUS.RejectedHighRisk,
          label: "Reject Applicant",
        },
        {
          value: CLIENT_SCORING_RESULT_SCORING_STATUS.Escalated,
          label: "Escalated",
        },
      ];
    }
    if (isManager) {
      return [
        {
          value: CLIENT_SCORING_RESULT_SCORING_STATUS.ApprovedHighRisk,
          label: "Approved High Risk",
        },
        {
          value: CLIENT_SCORING_RESULT_SCORING_STATUS.RejectedHighRisk,
          label: "Reject Applicant",
        },
      ];
    }

    if (isCoordinator) {
      if (allHaveDecision) {
        return [
          {
            value: CLIENT_SCORING_RESULT_SCORING_STATUS.Pending,
            label: "Pending",
            isDisabled: isNotPending,
          },
          {
            value: CLIENT_SCORING_RESULT_SCORING_STATUS.Escalated,
            label: "Escalated",
            isDisabled: isNotPending,
          },
          {
            value: CLIENT_SCORING_RESULT_SCORING_STATUS.RejectedHighRisk,
            label: "Reject Applicant",
            isDisabled: isNotPending,
          },
        ];
      }
    }
    return [
      {
        value: CLIENT_SCORING_RESULT_SCORING_STATUS.Pending,
        label: "Pending",
        isDisabled: isNotPending,
      },
      {
        value: CLIENT_SCORING_RESULT_SCORING_STATUS.Escalated,
        label: "Escalated",
        isDisabled: isNotPending,
      },
    ];
  };

  return (
    <React.Fragment>
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={clientScoringStatusValidationSchema}
      >
        <Form>
          <div className="monitoring-queue-entry-scoring-change-status">
            <div className="scoring-change-status-options">
              <p>Change scoring status:</p>
              <Field
                type="text"
                component={(props) => {
                  return (
                    <FormikButtonSelectScoring
                      {...props}
                      allDisabled={disabledAllOnNoDecision}
                      isDisabled={!canChangeScoringStatus || isNotPending}
                    />
                  );
                }}
                name="scoringStatus"
                placeholder="Scoring Status"
                className="dropdown-group"
                options={clientScoringResultScoringStatusOptions()}
              />
              <FieldSpy
                name="scoringStatus"
                onChange={handleScoringStatusChange}
              />
            </div>
            {isManager ? (
              <Button
                onClick={toggleModal}
                disabled={
                  clientScoringResultScoringStatusOptions().length < 1 ||
                  !canChangeScoringStatus ||
                  isHighRisk
                }
              >
                change
              </Button>
            ) : null}

            {isCoordinator ? (
              <Button
                onClick={toggleModal}
                disabled={
                  buttonDisabled ||
                  clientScoringResultScoringStatusOptions().length < 1 ||
                  !canChangeScoringStatus
                  // isNotPending
                }
              >
                change
              </Button>
            ) : null}

            {isMaster || isClient ? (
              <Button onClick={toggleModal} disabled={buttonDisabled || false}>
                change
              </Button>
            ) : null}

            {!isMaster && !isManager && !isCoordinator && !isClient ? (
              <Button disabled={true}>change</Button>
            ) : null}
          </div>
        </Form>
      </Formik>
      <ChangeStatusConfirmModal
        toggle={toggleModal}
        isOpen={isOpenModal}
        handleSubmit={handleSubmit}
        scoringStatus={scoringStatusValue}
      />
      <br />
      <br />
    </React.Fragment>
  );
};
MonitoringQueueEntryScoringChangeStatusForm.propTypes = {
  handleSubmit: func.isRequired,
  clientScoringResult: object.isRequired,
  setDataChange: func.isRequired,
  allHaveDecision: bool,
};

export default MonitoringQueueEntryScoringChangeStatusForm;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/scoring/change-status-form/MonitoringQueueEntryScoringChangeStatusForm.jsx